import React, { Component } from 'react';
import './Tela3.css';
import '../CampoDeRuido/A1/A1';

class Tela3 extends Component{
    render(){
        return(    
        <div className="grandeCampoPreto3">
            {this.props.children}
        </div>
        )
    }

}

export default Tela3;